import React, { useEffect, useState, useContext } from "react";
import { Field } from "formik";
import { isEmpty } from "lodash";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  SearchableList,
  AddButton,
  AddPlans,
  FieldButtonGroup,
  FieldDropSide,
  MultiSelectDropdown,
  FieldInputNumber,
  FieldInputPercentage,
  CsplTable as Table,
  SliderPanel,
} from "../../../../../components";
import {
  yesNoOptions,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  getNullTableItem,
  toMultiSelectValueById,
  usDateFormat,
  clearFieldValues,
} from "../../../../../utils";
import { manageRkaasStore } from "../../../../../contexts";
import AddRedemptionFee from "./AddRedemptionFee";
import TierDetails from "./TierDetails";

const holdingPeriodLabel = {
  1: "No of Calendar days for Holding period",
  2: "No of Business days for Holding period",
};

const RedemptionFees = (props) => {
  const { state, dispatch } = useContext(manageRkaasStore);
  const {
    fields,
    values,
    setValues,
    setFieldValue,
    isEdit,
    isSave,
    isAdd,
    handleChange,
    setTabGrey,
  } = props;
  const [tieredFeeType, setTieredFeeType] = useState("Calendar Days");

  const resetTierDetails = () => {
    setFieldValue(fields.holdingPeriodTieredFees, []);
  };
  const holdingPeriodTier = values[fields.holdingPeriod];
  useEffect(() => {
    holdingPeriodTier == 2
      ? setTieredFeeType("Business Days")
      : setTieredFeeType("Calendar Days");
  }, [holdingPeriodTier]);

  const clearFieldData = () => {
    setValues({
      ...clearFieldValues({
        values,
        fieldsToClear: [
          fields.sellTransactionsSubjectToRedemptionFees,
          fields.buyTransactionsSubjectToHoldingPeriod,
          fields.holdingPeriod,
          fields.isTieredFees,
          fields.holdingPeriodTieredFees,
          fields.holdingPeriodDays,
          fields.redemptionFee,
        ],
      }),
    });
  };

  return (
    <>
      <div>
        <Field
          label={"Investment subject to redemption fee?"}
          name={fields.investmentSubjectToRedemptionFee}
          size="sm"
          isRequired
          options={yesNoOptions}
          selectedValue={values[fields.investmentSubjectToRedemptionFee]}
          value={values[fields.investmentSubjectToRedemptionFee]}
          onChange={(value) => {
            setTabGrey(2);
            !value && clearFieldData();
            setFieldValue(fields.investmentSubjectToRedemptionFee, value);
            if (value) setFieldValue(fields.holdingPeriod, 1);
          }}
          component={FieldButtonGroup}
          disabled={isEdit && !isSave}
        />

        {values[fields.investmentSubjectToRedemptionFee] && (
          <div>
            <Field
              label={"Sell transactions subject to redemption fees"}
              size="md"
              name={fields.sellTransactionsSubjectToRedemptionFees}
              value={toMultiSelectValueById(
                values[fields.sellTransactionsSubjectToRedemptionFees],
                toOptionValuesFromMapper(
                  OPTIONS_DATA_MAPPER.REDEMPTION_SELL_TRANSACTIONS
                )
              )}
              isMultiSelect
              isRequired
              popupContent={
                <MultiSelectDropdown
                  label="Select"
                  name={fields.sellTransactionsSubjectToRedemptionFees}
                  onSelect={(value) => {
                    setTabGrey(2);
                    setFieldValue(
                      fields.sellTransactionsSubjectToRedemptionFees,
                      value
                    );
                  }}
                  value={values[fields.sellTransactionsSubjectToRedemptionFees]}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.REDEMPTION_SELL_TRANSACTIONS
                  )}
                />
              }
              disabled={isEdit && !isSave}
              component={FieldDropSide}
            />
            <Field
              label={"Buy transactions suject to holding period"}
              size="md"
              name={fields.buyTransactionsSubjectToHoldingPeriod}
              value={toMultiSelectValueById(
                values[fields.buyTransactionsSubjectToHoldingPeriod],
                toOptionValuesFromMapper(
                  OPTIONS_DATA_MAPPER.REDEMPTION_BUY_TRANSACTIONS
                )
              )}
              isMultiSelect
              isRequired
              popupContent={
                <MultiSelectDropdown
                  label="Select"
                  name={fields.buyTransactionsSubjectToHoldingPeriod}
                  onSelect={(value) => {
                    setTabGrey(2);
                    setFieldValue(
                      fields.buyTransactionsSubjectToHoldingPeriod,
                      value
                    );
                  }}
                  value={values[fields.buyTransactionsSubjectToHoldingPeriod]}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.REDEMPTION_BUY_TRANSACTIONS
                  )}
                />
              }
              disabled={isEdit && !isSave}
              component={FieldDropSide}
            />
            <div
              style={{
                fontWeight: "500",
                paddingBottom: "0.5rem",
                paddingTop: "0.5rem",
              }}
            >
              Holding period details
            </div>
            <Field
              label="Holding period"
              name={fields.holdingPeriod}
              value={values[fields.holdingPeriod]}
              isRequired
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.REDEMPTION_HOLDING_PERIOD
              )}
              popupContent={
                <SearchableList
                  isRadio
                  isNotTypeAhead
                  label="Select Holding period"
                  selectedValue={values[fields.holdingPeriod]}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.REDEMPTION_HOLDING_PERIOD
                  )}
                  onSelect={(value, label) => {
                    setTabGrey(2);
                    setFieldValue(fields.holdingPeriod, value);
                    setTieredFeeType(label);
                    values[fields.isTieredFees] &&
                      setFieldValue(fields.holdingPeriodTieredFees, [
                        {
                          tier: 1,
                          fromHoldingPeriod: 1,
                          toHoldingPeriod: null,
                          redemptionFee: null,
                        },
                      ]);
                  }}
                />
              }
              disabled={isEdit && !isSave}
              component={FieldDropSide}
            />
            <Field
              label={"Tiered fees for holding period"}
              size="sm"
              name={fields.isTieredFees}
              isRequired
              options={yesNoOptions}
              selectedValue={values[fields.isTieredFees]}
              value={values[fields.isTieredFees]}
              onChange={(value) => {
                setTabGrey(2);
                value
                  ? setFieldValue(fields.holdingPeriodTieredFees, [
                      {
                        tier: 1,
                        fromHoldingPeriod: 1,
                        toHoldingPeriod: null,
                        redemptionFee: null,
                      },
                    ])
                  : resetTierDetails();
                setFieldValue(fields.holdingPeriodDays, null);
                setFieldValue(fields.redemptionFee, null);
                setFieldValue(fields.isTieredFees, value);
              }}
              component={FieldButtonGroup}
              disabled={isEdit && !isSave}
            />
            {/* Check condition based on tiered yes or no */}
            {values[fields.isTieredFees] ? (
              <TierDetails
                values={values}
                fields={fields}
                tieredFeeType={tieredFeeType}
                isEdit={isEdit}
                isSave={isSave}
                isAdd={isAdd}
              />
            ) : (
              <>
                <Field
                  size="smd"
                  name={fields.holdingPeriodDays}
                  label={
                    values[fields.holdingPeriod] &&
                    holdingPeriodLabel[values[fields.holdingPeriod]]
                  }
                  type="number"
                  autoComplete="off"
                  value={values[fields.holdingPeriodDays]}
                  component={FieldInputNumber}
                  min={1}
                  max={
                    tieredFeeType == "Months" || tieredFeeType == "Years"
                      ? 99
                      : 999
                  }
                  onChange={(e) => {
                    setTabGrey(2);
                    handleChange(e);
                  }}
                  isRequired
                  disabled={isEdit && !isSave}
                />
                <Field
                  name={fields.redemptionFee}
                  size="xs"
                  label={"Redemption fee percentage"}
                  // min={0.01}
                  max={100.0}
                  type="number"
                  autoComplete="off"
                  value={values[fields.redemptionFee]}
                  component={FieldInputPercentage}
                  onChange={(e) => {
                    setTabGrey(2);
                    handleChange(e);
                  }}
                  isRequired
                  disabled={isEdit && !isSave}
                />
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default RedemptionFees;
